<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading">
            <div class="box-offset" v-show="showList">
                <div class="box-ttl-wrap">
                    <div class="box-ttl">
                        Uniforms
                    </div>
                </div>
                <div class="customise-tabs">
                    <div class="nav-tabs-wrap  pb-4">
                        <ul class="nav nav-tabs nav-tabs-three" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" :class="{ 'active': this.activeTab === 'Pending' }"
                                   @click="changeTab('Pending')">Pending</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ 'active': this.activeTab === 'Current' }"
                                   @click="changeTab('Current')">Current</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" :class="{ 'active': this.activeTab === 'Returned' }"
                                   @click="changeTab('Returned')">Returned</a>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content" >
                        <div class="tab-pane fade show active" >
                            <div class="buttons--row buttons--row-2 mb-3">
                                <div class="search--block">
                                    <button
                                        class="search--block-btn"
                                        type="submit"
                                        @click="getListOfUniformRequest"

                                    ><img src="/img/svg/icons-search.svg" alt=""></button>
                                    <input
                                        type="search"
                                        class="search--block-txt"
                                        placeholder="Search by Item"
                                        v-model="filters.search"
                                        @input="handleSearch"
                                    />
                                </div>
                                <a href="javascript:void(0)"
                                   class="btn btn--outline-primary btn--middle"
                                   v-show="activeTab === 'Pending'"
                                   @click="showTab"
                                >+ Add Request</a>
                            </div>
                            <div class="table-holder table-responsive">
                                <table class="table table-uniform">
                                    <thead>
                                    <tr>
                                        <th>Date <br/>{{title }}</th>
                                        <th>Item</th>
                                        <th class="text-center">Size</th>
                                        <th class="text-center">Qty</th>
                                        <th><nobr>Primary Location</nobr></th>
                                        <th
                                            class="text-right"
                                            style="width: 5rem"
                                        >Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                        v-for="request in uniformRequests"
                                        :key="request.id"
                                        v-show="request.quantity !== '0'"
                                    >
                                        <td>
                                            <div class="text-14 color--text-gray">
                                                {{ calculateDateSlash(request.created_at) }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ request.uniform.title }}
                                        </td>
                                        <td class="text-center">
                                            {{ request.size }}
                                        </td>
                                        <td class="text-center">
                                            {{ request.quantity }}
                                        </td>
                                        <td>
                                            {{ request.client ? request.client.name : request.address }}
                                        </td>
                                        <td class="text-right">
                                            <div class="action-block" v-show="activeTab === 'Pending'">
                                                <button class="delete-link"
                                                        @click="showDeleteModal(request.id)"
                                                >
                                                    <img src="/img/svg/on.svg" alt="delete">
                                                </button>
                                                <ActionModal confirm-text="Yes" reject-text="No"
                                                             :modalId="getDeleteModalId(request.id)"
                                                             @confirm="deleteRequestItem(request.id)">
                                                    <template #body>
                                                        <div class="text-center mb-4">
                                                            <h4>
                                                                Are you sure you want <br> to delete this item?
                                                            </h4>
                                                        </div>
                                                    </template>
                                                </ActionModal>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
                <Pagination
                    :currentPage="pagination.current_page"
                    :lastPage="pagination.last_page"
                    @changePage="changePage"
                    @changeItemsPerPage="changeItemsPerPage"
                />
            </div>
            <EmployeeAddUniform
                :user-name="userInfo.name + ' ' + userInfo.last_name"
                :user-id="userInfo.id"
                v-show="showNewRequest"
            >
            </EmployeeAddUniform>

        </div>
    </div>

</template>

<script>



import UniformsService from "../../../../Uniforms/resources/js/service/UniformsService";
import EyesShowModal from "../../../../../../resources/js/components/EyesShowModal.vue";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import EmployeeAddUniform from "./EmployeeAddUniform.vue";
import Pagination from "../../../../../../resources/js/components/Pagination.vue";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import EmployeeUniformsService from "../../../../Uniforms/resources/js/service/EmployeeUniformsService";
import {createDebouncedFunction} from "../../../../../../resources/js/plugins/debounce";


export default {
    name: 'EmployeeUniforms',
    components: {Pagination, EmployeeAddUniform, EyesShowModal, ActionModal},
    mixins: [PaginationHandler, ModalHandler, StyleHandler, DateConverter],
    props: {
        userInfo: {
            type: Object
        }
    },
    data() {
        return {
            loading: true,
            ascendingSort: true,
            activeTab: 'Pending',
            search_item: '',
            showNewRequest: false,
            showReturn: false,
            showList: true,
            uniformRequests: [],
            userInfoLoaded: false,
            filters: {
                search: '',
                page: 1,
                perPage: 10,
                status: '',
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getListOfUniformRequest(filters)
        },
        async getListOfUniformRequest() {
            try {
                const {data: response} = await EmployeeUniformsService.getEmployeeListOfRequests(this.userInfo.id, this.filters)
                this.uniformRequests = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        changeTab(tabName) {
            this.activeTab = tabName;

            if (tabName === 'Pending') {
                this.filters.status = ''
                this.getListOfUniformRequest()
            } else if (tabName === 'Current') {
                this.filters.status = 'Completed'
                this.getListOfUniformRequest()
            } else if (tabName === 'Returned') {
                this.getListOfReturnedUniforms()
            }
        },
        async getListOfReturnedUniforms() {
            try {
                const {data: response} = await EmployeeUniformsService.getReturnedUniforms(this.userInfo.id, this.filters)
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
                this.uniformRequests = response.data.map(request => ({
                    created_at: request.created_at,
                    id: request.id,
                    quantity: request.quantity,
                    address: request.request.address,
                    size:request.request.size,
                    uniform: request.request.uniform
                }));
            } catch (e) {
                console.error(e)
            }
        },

        async deleteRequestItem(id) {
            this.$showLoadingMessage()
            this.uniformRequests = this.uniformRequests.filter((request) => request.id !== id)
            $(`#modalId-${id}`).modal('hide');
            try {
                await UniformsService.deleteRequestByApplicant(id)
                this.$showSuccessMessageDelete();
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        showTab() {
            this.showNewRequest = true
            this.showReturn = false
            this.showList = false
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    computed :{
        title() {
            if(this.activeTab === "Pending") {
                return 'Requested'
            } else if (this.activeTab === "Current") {
                return 'Received'
            } else {
                return 'Returned'
            }
        }
    },
    mounted() {
        this.changeTab('Pending')
        this.getListOfUniformRequest()
        this.delayedSearch = createDebouncedFunction(() => this.getListOfUniformRequest(), 500);
    }
}


</script>

<style scoped>

</style>
